import jsonToCss from 'marketing-site/lib/jsonToCss'
import React from 'react'
import { IPageBehaviorComponentProps } from './PageBehaviors'

export default function CustomStyles({ children, data }: IPageBehaviorComponentProps) {
  // The jsonToCss function produces slightly different output on the server versus in the browser, so
  // this produces a console error in development builds. That doesn't seem to cause any issue, but we
  // should try to deprecate these custom styles.
  return (
    <>
      <style>{jsonToCss(data.configuration)}</style>
      {children}
    </>
  )
}
